import React, { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const steps = [
    {
        id: 1,
        number: "01",
        title: "Requirement Discussion",
        desc: "A developer works exclusively for your project, fully aligned with your processes and timelines to ensure success.",
    },
    {
        id: 2,
        number: "02",
        title: "Team Selection",
        desc: "We screen and select the best candidates that match your technical needs and company culture perfectly.",
    },
    {
        id: 3,
        number: "03",
        title: "Onboarding & Kickoff",
        desc: "Seamless onboarding process to get the team up to speed and productive from day one.",
    },
];

const HowItWorks = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    // --- SLIDER CONFIG ---
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
        loop: true, // Allows infinite scrolling
        slides: {
            perView: 1.3,
            spacing: 40,
        },
    });

    return (
        <section className="w-full py-16 lg:py-24 bg-white font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">
                <div className="mb-12 lg:mb-16">
                    <h2 className="text-[#0E2A62] text-[20px] md:text-[30px] font-[600] font-sora">
                        How It Works
                    </h2>
                </div>
            </div>
            <div className='max-w-[1440px] mx-auto w-full lg:pl-[80px] pl-[20px]'>
                <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
                    <div className="w-full lg:w-full max-w-[641px] h-[300px] md:h-[362px]">
                        <img
                            src="/assets/hire-n/img4.png"
                            alt="How It Works Process"
                            className="w-full h-full object-contain object-left"
                        />
                    </div>
                    <div className="w-full lg:w-1/2 relative">

                        <div className="absolute right-0 bottom-0 opacity-10 pointer-events-none translate-x-10 translate-y-10">
                            <img src="/assets/wave-pattern.svg" alt="" className="w-80" />
                        </div>

                        <div ref={sliderRef} className="keen-slider">
                            {steps.map((step) => (
                                <div key={step.id} className="keen-slider__slide py-4">

                                    <div className="flex flex-col gap-6">
                                        <span className="text-[#F06115] lg:text-[20px] text-[16px] font-[600] font-sora block tracking-wide">
                                            {step.number}
                                        </span>

                                        <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora leading-tight">
                                            {step.title}
                                        </h3>

                                        {/* Description */}
                                        <p className="text-[#49577A] text-[14px] md:text-[16px] leading-relaxed font-[500] max-w-lg font-graphik">
                                            {step.desc}
                                        </p>
                                    </div>

                                </div>
                            ))}
                        </div>

                        {/* Navigation Arrows (Controlled by Slider) */}
                        <div className="flex gap-4 mt-10">
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                                className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300 group"
                            >
                                <ArrowLeft size={18} className="transform transition-transform" />
                            </button>
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                                className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300 group"
                            >
                                <ArrowRight size={18} className="transform transition-transform" />
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default HowItWorks;